import React from 'react'
import { Link } from 'react-router-dom'
import MetaTags from '../components/MetaTags'

export default function NotFound() {
  return (
    <div className="min-h-[60vh] py-20 flex items-center justify-center bg-[#FAF9F5]">
      <MetaTags
        title="Siden blev ikke fundet - Elses skrub og skur"
        description="Siden du leder efter findes desværre ikke. Gå tilbage til forsiden af Elses skrub og skur eller kontakt mig."
      />

      <div className="max-w-lg mx-auto px-4 text-center space-y-6">
        <div className="w-20 h-20 rounded-3xl bg-[#EEF4F0] text-[#285F41] flex items-center justify-center text-3xl mx-auto border border-[#D2E0D6]">
          <i className="fa-regular fa-compass-slash" aria-hidden="true"></i>
        </div>

        <div className="space-y-2">
          <span className="text-xs font-mono font-bold uppercase tracking-widest text-[#3A684D]">
            Fejl 404
          </span>
          <h1 className="text-3xl font-serif-display font-bold text-[#285F41]">
            Siden blev ikke fundet
          </h1>
          <p className="text-sm text-[#4A5D50] leading-relaxed">
            Jeg kunne desværre ikke finde den side, du leder efter. Den kan være flyttet eller slettet.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 pt-2">
          <Link
            to="/"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 rounded-xl bg-[#285F41] text-white font-semibold text-sm hover:bg-[#357753] transition-colors"
          >
            <i className="fa-regular fa-house text-xs" aria-hidden="true"></i>
            <span>Gå til forsiden</span>
          </Link>

          <Link
            to="/kontakt"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 rounded-xl bg-white text-[#285F41] font-semibold text-sm border border-[#D2E0D6] hover:bg-[#EEF3EF] transition-colors"
          >
            <i className="fa-regular fa-envelope text-xs" aria-hidden="true"></i>
            <span>Kontakt mig</span>
          </Link>
        </div>
      </div>
    </div>
  )
}
